VogUtils.DOMready(() => {
  const collectionItem = document.querySelector(".collection__description-item_new");
  if (!collectionItem) return;
  if (Number(collectionItem.scrollHeight) > Number(collectionItem.offsetHeight)) {
    $vog(".collection__filters_More").show();
  } else {
    $vog(".collection__filters_More").hide();
  }
  const options = document.querySelector(".collection__filters_More");
  const img = document.querySelector(".collection__filters_More-img");
  const line = document.querySelector(".collection__description-item_new");
  if (!options) return;
  options.addEventListener("click", (e) => {
    const isClamped = line.classList.contains("line-clamp3");
    if (isClamped) {
      line.classList.remove("line-clamp3");
      img.classList.add("up");
    } else {
      line.classList.add("line-clamp3");
      img.classList.remove("up");
    }
  });
});
